import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, mergeProps as _mergeProps } from "vue"

import { useProgramsStore } from '@/stores/programs';
import { useUiStore } from '@/stores/ui';


export default /*#__PURE__*/_defineComponent({
  __name: 'AnaliticsCell',
  props: {
    program: null,
    groupReport: null,
    teamId: null,
    showMiss: { type: Boolean },
    mode: null
  },
  setup(__props: any) {

const props = __props as { program: any, groupReport: any, teamId: string, showMiss?: boolean, mode?: string }


const programsStore = useProgramsStore()

const report = props.groupReport.find((item: any) => item.teamId === props.teamId)

const stage = report?.programStageId && programsStore.stages.find(item => item.id === report.programStageId)
const tooltip = stage?.name || "Трекер не прислал отчет"

const uiStore = useUiStore()

const getColor = (report: any) => {
  let val = report.executionScore
  if (props.mode === "diary") 
    val = report.diaryScore
  if (val >= 5) return "#CDFED5"
  if (val >= 4) return "#FEF3CD"
  if (val >= 3) return "#FECDCD"
  return "transparent"
}

const onClick = async (e: MouseEvent) => {
  const team = programsStore.teams.find(item => item.id === props.teamId)
  if (!team) return
  e.stopPropagation()
  uiStore.team = team
  if (!team?.reports) {
    await programsStore.requestReports(team!)
  }
  const _report = team.reports.find((item: any) => item.id === report.id)
  if (_report) {
    uiStore.selectedReport = _report
  }
}


return (_ctx: any,_cache: any) => {
  return (_unref(report))
    ? (_openBlock(), _createElementBlock("div", _mergeProps({ key: 0 }, props, {
        class: "analitics-cell",
        style: { backgroundColor: getColor(_unref(report)) },
        onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (_unref(uiStore).openTooptip($event, _unref(tooltip)))),
        onClick: onClick
      }), [
        (props.mode === 'execution' || props.mode === 'both')
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass(["bold", { red: _unref(report).executionScore < 4 }])
            }, _toDisplayString(_unref(report).executionScore), 3))
          : _createCommentVNode("", true),
        (props.mode === 'both')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode("/")
            ], 64))
          : _createCommentVNode("", true),
        (props.mode === 'diary' || props.mode === 'both')
          ? (_openBlock(), _createElementBlock("span", {
              key: 2,
              class: _normalizeClass({ red: _unref(report).diaryScore < 4 })
            }, _toDisplayString(_unref(report).diaryScore), 3))
          : _createCommentVNode("", true)
      ], 16))
    : (props.showMiss)
      ? (_openBlock(), _createElementBlock("div", _mergeProps({ key: 1 }, props, {
          onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (_unref(uiStore).openTooptip($event, _unref(tooltip)))),
          className: "analitics-cell__miss"
        }), " - ", 16))
      : _createCommentVNode("", true)
}
}

})